export default __webpack_public_path__ + "static/media/leaf_unselected.e264cde6.svg";